module.exports = __webpack_public_path__ + "a17d279f/img/trash-icon.ff8201c7.svg";